export const RETRY_FETCH = 'mallBonuses/RETRY_FETCH';
